(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-v2"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const faqItems = document.querySelectorAll('.faq-v2__item');
    faqItems.forEach(item => {
      item.addEventListener('click', function() {
        item.classList.toggle('opened');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
